import { render, staticRenderFns } from "./_ewallet.vue?vue&type=template&id=7da70b7e&scoped=true&lang=pug&"
import script from "./_ewallet.vue?vue&type=script&lang=js&"
export * from "./_ewallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da70b7e",
  null
  
)

export default component.exports